export const headerStyles = {
  container: {
    height: '80px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: { xs: 0.5, sm: 2, md: 3 },
    bgcolor: 'background.paper',
    borderBottom: '1px solid',
    borderColor: 'grey.200',
    boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
    position: 'sticky',
    top: 0,
    zIndex: 1100,
  },

  leftSection: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: 1, sm: 3 },
  },

  hamburgerButton: {
    color: 'text.primary',
    '&:hover': {
      bgcolor: 'grey.100',
    },
  },

  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: 1, sm: 9 },
  },

  logoImage: isMobile => ({
    height: isMobile ? '40px' : '70px',
    width: 'auto',
    objectFit: 'contain',
  }),

  brandContainer: {
    display: { xs: 'none', sm: 'block' },
  },

  brandTitle: {
    fontWeight: 700,
    fontSize: '1.25rem',
    lineHeight: 1,
    mb: 0.5,
  },

  brandSubtitle: {
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    lineHeight: 1,
  },

  rightSection: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: '3.5px', sm: 0.75, md: 1 },
  },

  iconButton: {
    color: 'text.secondary',
    p: { xs: 0.5, sm: 1 },
    '&:hover': {
      bgcolor: 'grey.100',
      color: 'primary.main',
    },
  },

  divider: {
    width: '1px',
    height: '24px',
    bgcolor: 'grey.300',
    mx: 1,
  },

  profileButton: {
    p: { xs: 0.25, sm: 0.5 },
    '&:hover': {
      bgcolor: 'grey.100',
    },
  },

  avatar: {
    width: { xs: 26, sm: 32, md: 36 },
    height: { xs: 26, sm: 32, md: 36 },
    bgcolor: 'primary.main',
    fontSize: { xs: '0.75rem', sm: '0.875rem' },
    fontWeight: 600,
  },

  avatarIcon: {
    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.25rem' },
  },
};
